import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../appUtils/axiosConfig";

const initialState = {
    isLoading: false,
    error: null,
    events: [],
    isEventLoading: false,
    eventconfig: [],
    isSearchLoading: false,
    searchevents: []


}


export const getEvents = createAsyncThunk(
    'get_event_page',
    async ({ status, searchText }, { dispatch, rejectWithValue }) => {

        try {
            dispatch(getEventsStart());
            const response = await axios.get(`/events/get_events.php?status=${status || ''}&search=${searchText || ''}`)
            if (response?.data?.status == 'success') {
                dispatch(getEventsSuccess(response?.data?.data))
                // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
            }

        } catch (error) {
            dispatch(getEventsFailure(error.response.data.message))
        }
    }
)
export const addEvent = createAsyncThunk(
    "addevents",
    async (data, { dispatch, rejectWithValue }) => {
        console.log('data os eventData ', data)
        try {
            dispatch(addEventStart());
            const response = await axios.post(`/events/add_event.php`, data);
            dispatch(addEventSuccess(response.data?.user));
            if (response?.data?.status == 'success') {
                dispatch(getEvents())
                // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
            }
            return response.data
        } catch (error) {
            dispatch(addEventFailure(error.response.data.message));
            // SHOW_ERROR_NOTIFICATION(error.response.data.message);
            return rejectWithValue(error.response.data.message);
        }
    }
);
export const deleteEvent = createAsyncThunk('deleteevent', async (id, { dispatch, rejectWithValue }) => {
    try {
        dispatch(updateEventStart());
        const response = await axios.delete(`events/delete_event.php?id=${id}`);
        if (response?.data?.status == 'success') {
            dispatch(getEvents())
            // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
        }
        return response.data
    } catch (error) {
        // SHOW_ERROR_NOTIFICATION(error.response.data.message);
        return rejectWithValue(error.response.data.message);
    }
})
export const updateEvent = createAsyncThunk(
    "addevents",
    async ({ data }, { dispatch, rejectWithValue }) => {
        console.log('data os eventData ', data)
        try {
            dispatch(updateEventStart());
            const response = await axios.post(`events/update_event.php`, data);
            dispatch(updateEventSuccess(response.data?.user));
            if (response?.data?.status == 'success') {
                dispatch(getEvents())
                // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
            }
            return response.data
        } catch (error) {
            dispatch(updateEventFailure(error.response.data.message));
            // SHOW_ERROR_NOTIFICATION(error.response.data.message);
            return rejectWithValue(error.response.data.message);
        }
    }
);
export const addEventConfig = createAsyncThunk(
    "addcontactus",
    async (data, { dispatch, rejectWithValue }) => {
        try {
            const response = await axios.post(`/events/add_event_config.php`, data);
            if (response?.data?.status == 'success') {
                dispatch(getEventConfig())
                // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
            }
            return response.data
        } catch (error) {
            // SHOW_ERROR_NOTIFICATION(error.response.data.message);
            return rejectWithValue(error.response.data.message);
        }
    }
);

export const getEventConfig = createAsyncThunk(
    'get_config_page',
    async (_, { dispatch, rejectWithValue }) => {

        try {
            dispatch(getEventConfigStart());
            const response = await axios.get(`/events/get_event_config.php`)

            if (response?.data?.status == 'success') {

                dispatch(getEventConfigSuccess(response?.data?.data))
            }


        } catch (error) {
            dispatch(getEventConfigFailure(error.response.data.message))
        }
    }
)

export const getSearchEvents = createAsyncThunk(
    'events_search',
    async (searchText, { dispatch, rejectWithValue }) => {

        try {
            dispatch(getSearchEventsStart());
            const response = await axios.get(`/events/events_search.php?q=${searchText}`)
            if (response?.data?.status == 'success') {

                dispatch(getSearchEventsSuccess(response?.data?.data))
            }


        } catch (error) {
            dispatch(getSearchEventsFailure(error.response.data.message))
        }
    }
)
const eventsSlice = createSlice({
    name: 'events',
    initialState,
    reducers: {
        getEventsStart(state) {
            state.isLoading = true;
            state.error = null;
        },
        getEventsSuccess(state, action) {

            state.events = action.payload;
            state.isLoading = false;
        },
        getEventsFailure(state, action) {
            state.events = null;
            state.isLoading = false;
            state.error = action.payload;

        },
        addEventStart(state) {
            state.isEventLoading = true;
            state.error = null;
        },
        addEventSuccess(state, action) {
            state.user = action.payload;
            state.isEventLoading = false;
        },
        addEventFailure(state, action) {
            state.error = action.payload;
            state.isEventLoading = false;
        },

        updateEventStart(state) {
            state.isEventLoading = true;
            state.error = null;
        },
        updateEventSuccess(state, action) {
            state.user = action.payload;
            state.isEventLoading = false;
        },
        updateEventFailure(state, action) {
            state.error = action.payload;
            state.isEventLoading = false;
        },
        getEventConfigStart(state) {
            state.isLoading = true;
            state.error = null;
        },
        getEventConfigSuccess(state, action) {

            state.eventconfig = action.payload;
            state.isLoading = false;
        },
        getEventConfigFailure(state, action) {
            state.eventconfig = null;
            state.isLoading = false;
            state.error = action.payload;

        },
        getSearchEventsStart(state) {
            state.isSearchLoading = true;
            state.error = null;
        },
        getSearchEventsSuccess(state, action) {

            state.searchevents = action.payload;
            state.isSearchLoading = false;
        },
        getSearchEventsFailure(state, action) {
            state.searchevents = null;
            state.isSearchLoading = false;
            state.error = action.payload;

        },
    }
})

export const { getEventsSuccess, getEventsStart, getEventsFailure, getEventConfigSuccess, getEventConfigStart, getEventConfigFailure, addEventStart, addEventSuccess, addEventFailure, updateEventStart, updateEventSuccess, updateEventFailure, getSearchEventsSuccess, getSearchEventsStart, getSearchEventsFailure } = eventsSlice.actions;

export default eventsSlice.reducer;